<template>
  <page no-styling>
    <transition name="slide">
      <div v-show="displayStep === 0">

        <div class="card flex column">
          <card-header
            :title="`${displayStep + 1} ${$t('cms.addcolleague.IntroTitle')}`"
            :description="$t('cms.addcolleague.IntroText')"
          >
            <template #icon>
              <icon addColleagueNew xlarge />
            </template>
          </card-header>

          <input
            id="email"
            name="email"
            v-validate="'required|email'"
            v-model="newUser.email"
            type="email"
            :placeholder="$t('cms.addcolleague.EnterEmailInput')"
            class="box center_text"
            :class="{ 'error': errors.has('email') }"
          >

          <button
            class="box primary center_text"
            :disabled="!emailIsValid"
            type="button"
            @click="emailIsSet = true"
          >{{ $t('cms.addcolleague.NextButton') }}</button>
        </div>
      </div>
    </transition>

    <transition name="slide">
      <div v-show="displayStep === 1">
        <div class="card flex column" :class="{loading: loading}">
          <card-header
            :title="`${displayStep + 1} ${$t('cms.addcolleague.AuthorityTitle')}`"
            :description="$t('cms.addcolleague.AuthorityText')"
          >
            <template #icon>
              <icon invite-auth xlarge />
            </template>
          </card-header>

          <div class="flex">
            <button
              class="box grow mr1"
              type="button"
              @click="newUser.isAdmin = true"
              :class="{secondary: newUser.isAdmin}"
            >{{ $t('cms.addcolleague.YesButton') }}</button>

            <button
              class="box grow ml1"
              type="button"
              @click="newUser.isAdmin = false"
              :class="{secondary: !newUser.isAdmin}"
            >{{ $t('cms.addcolleague.NoButton') }}</button>
          </div>

          <button class="box primary" type="button" @click="validateAndSubmit">
            {{ $t('cms.addcolleague.SendButton') }}
          </button>
        </div>
      </div>
    </transition>

    <transition name="slide">
      <div v-show="displayStep === 2">
        <div class="card flex column">
          <card-header
            :title="`${displayStep + 1} ${$t('cms.addcolleague.InviteSentTitle')}`"
            :description="`${$t('cms.addcolleague.InviteSentText')} ${sentToEmail}.`"
          >
            <template #icon>
              <icon done-redeem xlarge />
            </template>
          </card-header>

          <button @click="reset" class="primary box" type="button">
            {{ $t('cms.addcolleague.AnotherColleagueButton') }}
          </button>
        </div>
      </div>
    </transition>
  </page>
</template>

<script>
import get from 'lodash/get';
import CardHeader from '@/components/global/CardHeader.vue';

export default {
  name: 'invite-colleague',

  components: {
    CardHeader,
  },

  data() {
    return {
      newUser: this.$MODELS.user,
      emailIsSet: false,
      sentToEmail: false,
      loading: false,
    };
  },

  computed: {
    displayStep() {
      return this.sentToEmail
        ? 2
        : +this.emailIsSet;
    },

    emailIsValid() {
      return !this.errors.has('email') && (this.fields.email && !this.fields.email.invalid);
    },
  },

  methods: {
    reset() {
      this.newUser.email = '';
      this.emailIsSet = false;
      this.sentToEmail = false;
      this.loading = false;
    },

    async validateAndSubmit() {
      if (!await this.$validator.validate()) { return; }

      const inviteUserInput = {
        email: this.newUser.email,
        isAdmin: this.newUser.isAdmin,
      };

      this.loading = true;
      const { data, errors } = await this.$mutate(this.$mutations.inviteUser, { inviteUserInput });
      this.loading = false;

      if (errors.length > 0 || !get(data, 'inviteUser.ok')) {
        this.handleErrors(errors);
      } else {
        this.sentToEmail = this.newUser.email;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-enter-active, .slide-leave-active {
  height: 0;
}
</style>
